import React from 'react';
import { Box } from '@mui/material';

type LockedFieldProps = {
  label: string;
  value: string;
};

export default function LockedField({
  label,
  value,
}: LockedFieldProps) {
  return (
    <Box>
      <label className="form-field-label">{label}</label>
      <Box
        sx={{
          boxSizing: 'border-box',
          height: 36,
          display: 'flex',
          alignItems: 'center',
          px: '8px',
          fontSize: 13,
          color: '#98a2b3',
          backgroundColor: '#eceef1',
          border: '0.5px solid #d0d5dd',
          borderRadius: '4px',
          cursor: 'not-allowed',
        }}>
        {value}
      </Box>
    </Box>
  );
}
